module.exports = __webpack_public_path__ + "static/media/usb-a-silver.5f9e7335.svg";